import { useEffect, useState } from 'react';
import Pagination from '@src/common/Pagination';
import { useDispatch } from 'react-redux';
import {getAgencyUsers} from '@src/store/slices/agency';
import AddAgencyUserPopup from './AddAgencyUserPopup';
import AgencyUserListPopup from './AgencyUserListEdit'
import FullPageLoader from '@src/common/FullPageLoader';
import { PAGE_NUMBER, STATUS_SUCCESS } from '@src/config/constant';


function AgencyUserListTable(props: any) {

    const dispatch: any = useDispatch();
    let [userAgencyManageList, setAgencyUserManageList] = useState<any>([]);
    const [showUserPopup, setUserPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [paginationData, setPaginationData] = useState<any>({});
    let [searchText, setSearchText] = useState('');
    const [showUserRole, setShowUserRole] = useState(false);
    let [userDataToEdit, setUserDataToEdit] = useState<any>({});
    let [filterData, setFilterData] = useState<any>({});

    const getUserManageListDetails = async (params: any) => {
        let filters = {
            ...params,
            page_number: params?.page_number ?? PAGE_NUMBER,
            isPaginationApply: true,
            agency_id : props?.agency_id
        }

        setFilterData(filters);

        setLoading(true);
        dispatch(getAgencyUsers(filters)).then((res: any) => {
            setLoading(false);
            if (res && res.status === STATUS_SUCCESS) {

                res.data = res?.data?.map((data: any) =>{
                    let {password, ...rest} = data;
                    return rest });   /// Remove password by default
                setPaginationData({ ...res?.pagination });
                setAgencyUserManageList([...res?.data]);
            }
        }).catch((err: Error) => {
            setLoading(false);
        })
    };


    const searchUser = (event: any) => {

        let value = event.target.value;
        setSearchText(value);
    }

    const addNewUser = (action: boolean = true) => {
        setShowUserRole(action);
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }


    const userEditPopup = (action: boolean, userData: any) => {
        setUserPopup(action);
        action ? setUserDataToEdit(userData) : setUserDataToEdit({}); 
        document.body.classList.remove("overflow-hidden");
        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const handleRequestData = (params: any) => {
        let apiParams = {
            page_number: params.page_no
        }

        getUserManageListDetails({...filterData, ...apiParams});

    }

    const getApiData = async () => {
        await getUserManageListDetails({});
    }

    useEffect(() => {
        if(props?.agency_id){
            getApiData();
        }
        // eslint-disable-next-line
    }, [props.agency_id,props.triggerAgencyList]);

    /**
     * ON ENTER SEARCH 
     * @param event 
     */
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {

            getUserManageListDetails({...filterData, searchKeyword: searchText?.trim() || undefined, page_number: PAGE_NUMBER});
        }
    }


    return (

        <>
             <FullPageLoader show={loading} />
             <div className="top-filter-bg user-management-inner-tabs">
             <div className='search-user-add-btn agencyUser'>
                                <fieldset className="search-bx m-md-r">
                                    <div className="material">
                                        <input id="Search" type="text" placeholder="Search User by name, email, mobile..." onChange={(e: any) => searchUser(e)} value={searchText} className="form-input" onKeyDown={handleKeyDown} />
                                        <i className="ic-search"></i>
                                    </div>
                                </fieldset>
                                <button className="btn-line" onClick={() => addNewUser(true)}>
                                    <span>Add User</span>
                                </button>
                            </div>   
            </div>

 
                <div className="lead-list-data-table user-managment-table-data m-lg-t">
                    <table>
                        <thead>
                            <tr>
                                <th>User Name</th>
                                <th>Email ID </th>
                                <th>Mobile No</th>
                                <th>Status</th>
                                <th>Edit</th>
                                </tr>
                        </thead>
                        <tbody>
                            {( userAgencyManageList?.length > 0) ? userAgencyManageList?.map((row: any, index: number) => (
                                <tr key={index}>
                                    <td>{row.name}</td>
                                    <td title={row.email}>{row.email}</td>
                                    <td>{row.mobile}</td>
                                    <td><span className={+row.status ? "active-dot" : "inactive-dot"}>{+row.status ? "Active" : "InActive"}</span></td>
                                    <td>
                                        <ul className="action-btn">
                                            {row.is_editable ?
                                                <li onClick={() => userEditPopup(true, row)}>
                                                    <i className="ic-edit"></i>
                                                </li>
                                                :
                                                <li>
                                                    <i className="ic-edit"></i>
                                                </li>

                                            }
                                        </ul>

                                    </td>
                                </tr>
                            )) : 
                            <tr><td colSpan={5} style={{ textAlign: 'center' }}>No data found</td></tr>
                        }
                        </tbody>
                    </table>

                    {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                        page: 1,
                        loading: false,
                        totalLengthWithoutPagination: paginationData['total'],
                        paginationData,
                        filteredData: filterData
                    }}
                        sendRequestDataToParent={handleRequestData} />}

                    {showUserPopup && <AgencyUserListPopup
                        showUserPopup={showUserPopup}
                        userEditPopup={(e: boolean) => {
                            userEditPopup(e, {});
                        }}
                        userDetails={userDataToEdit}
                        setLoading={setLoading}
                        setSearchText = {setSearchText}
                        setTriggerAgencyList = {props.setTriggerAgencyList}
                        triggerAgencyList = {props.triggerAgencyList}
                        />}

                     {showUserRole && <AddAgencyUserPopup
                        showUserRole={showUserRole}
                        setLoading={setLoading}
                        addNewUser={(e: boolean) => {
                            addNewUser(e);
                        }} 
                        setSearchText = {setSearchText}
                        agency_id = {props?.agency_id} 
                        setTriggerAgencyList = {props.setTriggerAgencyList}
                        triggerAgencyList = {props.triggerAgencyList}
                        />}
                </div>
        </>
    )
}

export default AgencyUserListTable

